<template>
  <div class="orderStationSettle">

    <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="114px"
        label-position="left"
    >

      <el-form-item label="车站劳务费" prop="ratio">
        <div>
          提取订单金额的
          <el-input style="width: 120px" v-model="form.ratio"
                    v-input-filter="{ min: 0, max: 100, precision: 2 }">
            <template slot="append">%</template>
          </el-input>
        </div>
      </el-form-item>

      <el-form-item label="税费" prop="ratio4">
        <div>
          提取订单金额的
          <el-input style="width: 120px" v-model="form.ratio4"
                    v-input-filter="{ min: 0, max: 100, precision: 2 }">
            <template slot="append">%</template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="车站站务费" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="1">固定金额</el-radio>
          <el-radio :label="2">阶梯规则</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item>
        <div>
          <div v-if="form.type == 1">
            <el-form-item prop="fee">
              每位乘客提取
              <el-input style="width: 135px" v-model="form.fee"
                        v-input-filter="{ min: 0, max: 999999, precision: 2 }">
                <template slot="suffix">元</template>
              </el-input>
            </el-form-item>
          </div>

          <div v-if="form.type == 2">
            <div v-for="(item, index) in form.rule" :key="index" style="display: flex;margin-bottom: 10px">
              <span style="margin-right: 6px">当客票金额为</span>

              <el-input style="width: 100px" v-model="item.minFee">
                <template slot="suffix">元</template>
              </el-input>

              <span style="margin: 0 6px 0 6px">至</span>
              <el-form-item label="" :prop="'rule.' + index + '.maxFee'"
                            :rules="[{ required: true, message: '请输入订单金额' }]">
                <el-input v-input-filter="{ min: 0, max: 999.99, precision: 2 }"
                          style="width: 100px" v-model="item.maxFee">
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>


              <span style="margin: 0 6px 0 10px">每张客票提取</span>
              <el-form-item label="" :prop="'rule.' + index + '.fee'"
                            :rules="[{ required: true, message: '请输入提取比例' }]">
                <el-input v-input-filter="{ min: 0, max: 99999999.9, precision: 2 }" style="width: 100px"
                          v-model="item.fee">
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
              <div style="width: 20px"></div>
              <div>
                <el-button type="text" v-if="index>0" @click="deleteList(index)"
                           class="testlist">删除
                </el-button>
              </div>
            </div>
          </div>
          <div v-if="form.type == 2 && form.rule.length<5" class="add" @click="addClicks(2)">
            <i class="el-icon-plus"></i>添加阶梯规则
          </div>
        </div>
      </el-form-item>

      <el-form-item label="费用展示">

        <div class="util-remark">
          <el-switch
              active-value="1"
              inactive-value="2"
              v-model="formII.isShow">
          </el-switch>
          如关闭费用展示，则管理后台的班次详情、司机端历史工单、流水记录将不再展示车站劳务费、税费和车站站务费信息
        </div>

      </el-form-item>
      <el-form-item label="其他项目">
        <div v-for="(item, index) in form.settleList" :key="index" style="display: flex;margin-bottom: 20px">
          <span style="margin-right: 6px">项目名称</span>
          <el-form-item label="" :prop="'settleList.' + index + '.name'"
                        :rules="[{ required: true, message: '请输入项目名称' }]">
            <el-input style="width: 130px" v-model="item.name" placeholder="请输入项目名称">
            </el-input>
          </el-form-item>
          <span style="width: 30px"></span>
          <span style="margin-right: 6px">金额</span>
          <el-form-item label="" :prop="'settleList.' + index + '.fee'"
                        :rules="[{ required: true, message: '请输入项目金额' }]">
            <el-input v-input-filter="{ min: 0, max: 9999999.9, precision: 2 }" style="width: 130px"
                      v-model="item.fee">
              <template slot="suffix">元</template>
            </el-input>
          </el-form-item>

          <div style="display: flex">
            <span style="margin-left: 20px;color: #1e8fe9;cursor: pointer" @click="deleteList2(index)"
                  class="testlist">删除
            </span>
          </div>

        </div>
        <div>
          <div class="add" style="width: 385px" @click="addClicks(3)" v-if="form.settleList.length<10">
            <i class="el-icon-plus"></i>添加结算项目
          </div>
        </div>
      </el-form-item>


      <el-form-item style="padding: 10px 0 50px 0">
        <el-button type="primary" @click="saveClick" :loading="loading"
        >保存
        </el-button
        >
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
export default {
  name: "orderStationSettle",
  data() {
    return {
      formII: {
        isShow: '2',
      },
      form: {
        type: 1,
        ratio: '',
        ratio4: '',
        fee: "",
        rule: [
          {
            "minFee": 0,
            "maxFee": '',
            "fee": ''
          },
        ],
        settleList: []
      },

      rules: {
        type: [{required: true, message: '请选择车站站务费收费类型', trigger: ['blur', 'change']}],
        ratio: [{required: true, message: '请输入车站劳务费', trigger: ['blur', 'change']}],
        ratio4: [{required: true, message: '请输入税费', trigger: ['blur', 'change']}],
        fee: [{required: true, message: '请输入车站站务费', trigger: ['blur', 'change']}],
      },
      loading: false,
    }
  },
  mounted() {
    this.getInitFn()
    this.getInitShowFn()
  },
  methods: {
    async getInitShowFn() {
      const url = "/api/v1/manage/systems/station/settle/config"
      const {code, data} = await this.$axios.get(url,{
        organizationId: this.mixinUserInfo.organizationId
      })
      if (code === 1 && data) {
        this.formII = {
          isShow: String(data.isShow)
        }
      }
    },
    async getInitFn() {
      const url = "/api/v1/manage/systems/station/settle"
      const {code, data} = await this.$axios.get(url, {
        organizationId: this.mixinUserInfo.organizationId
      })
      console.log(data, 34434);
      if (code === 1 && data && data.length) {
        data.forEach((item) => {
          if (item.settleItem === 1) {
            this.form = {
              ...this.form,
              ...item,
              type: item.type,
              rule: item.ruleList || [],
            }
          }

          if (item.settleItem === 2) {
            this.form = {
              ...this.form,
              ratio: item.ratio,
            }
          }
          if (item.settleItem === 3) {
            this.form.settleList.push(item)
          }

          if (item.settleItem === 4) {
            this.form.ratio4 = item.ratio
          }
        })

        // this.form = {
        //   ...data[0],
        //   type: data[0].type,
        //   ratio: data[1].ratio,
        //   settleList: data.slice(2, data.length)
        // }
        // if (this.form.type == 1) {
        //   this.form.rule = [
        //     {
        //       "minFee": 0,
        //       "maxFee": '',
        //       "fee": ''
        //     },
        //   ]
        // }
        //
        // if (this.form.ruleList && this.form.ruleList.length) {
        //   this.form.rule = this.form.ruleList
        // }
      }
    },
    deleteList(index) {
      this.form.rule.splice(index, 1)
    },
    deleteList2(index) {
      this.form.settleList.splice(index, 1)
    },
    saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn()
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    addClicks(type) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (type == 2) {
            let num = this.form.rule.length && this.form.rule[this.form.rule.length - 1].maxFee || 0;
            let obj = {
              "minFee": num || 0,
              "maxFee": '',
              "fee": ''
            };
            this.form.rule.push(obj);
          } else if (type == 3) {

            let obj = {
              settleItem: 3,
              name: "",
              type: 1,
              fee: "",
              nameField: ""
            };
            this.form.settleList.push(obj);
          }

        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    async postFn() {
      const obj1 = this.form.type === 1 ? {
        settleItem: 1,
        type: this.form.type,
        fee: this.form.fee,
        name: '车站站务费',
        organizationId: this.mixinUserInfo.organizationId
      } : {
        settleItem: 1,
        type: this.form.type,
        rule: this.form.rule,
        name: '车站站务费',
        organizationId: this.mixinUserInfo.organizationId
      }

      const obj2 = {
        settleItem: 2,
        type: 3,
        name: "车站劳务费",
        ratio: this.form.ratio,
        organizationId: this.mixinUserInfo.organizationId
      }

      const obj3 = {
        settleItem: 4,
        type: 3,
        name: "税费",
        ratio: this.form.ratio4,
        organizationId: this.mixinUserInfo.organizationId
      }
      const arr3 = this.form.settleList.map((item, index) => {
        return {
          ...item,
          nameField: 'nameField' + (index + 1),
          organizationId: this.mixinUserInfo.organizationId
        }
      })
      const params = [obj1, obj2, obj3, ...arr3,]
      this.loading = true
      const url = "/api/v1/manage/systems/station/settle"
      this.loading = false
      const {code} = await this.$axios.post(url, {
        stationSettleJson: JSON.stringify(params),
        isShow:this.formII.isShow
      })

      if (code === 1) {
        this.$message.success('操作成功')
      }
    }
  }
}
</script>

<style scoped lang="less">

.orderStationSettle {
  .add {
    margin-top: 12px;
    width: 515px;
    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }

}


</style>